export class ObjectStatItem {
  constructor(private readonly type: string, private readonly value: string, private readonly count: number) {}

  getType() {
    return this.type;
  }

  getValue() {
    return this.value;
  }

  getCount() {
    return this.count;
  }
}
